import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import { I18n, DataBlocks } from 'components';
import { formatDateString } from 'utils/formatString';

import { hideMnpStatusForSession } from '../../actions';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const MnpStatus = ({
  data,
  actions,
  isMnpStatusHidden,
}) => {
  const {
    text,
    isPortationSuspended,
    description,
    applyId,
    actualDate,
  } = data || {};

  if (isMnpStatusHidden || !data) {
    return null;
  }

  return (
    <DataBlocks.Block
      className={isPortationSuspended ? 'alert' : 'attention'}
      ariaLabel="Информация о подключении домашнего интернета"
      title={text}
      info={(
        <button
          className={cx('closeButton')}
          type="button"
          onClick={actions.hideMnpStatusForSession}
        >
          &#10005;
        </button>
      )}
    >
      <div className={cx('description')}>
        {description}
      </div>
      <I18n
        path="home.mnpStatus.applyId"
        vars={{ id: applyId }}
      />
      &nbsp;
      <I18n
        path="home.mnpStatus.actualDate"
        vars={{ date: formatDateString(actualDate, 'D MMMM YYYY, HH:mm') }}
      />
    </DataBlocks.Block>
  );
};

function mapStateToProps(state) {
  const {
    isMnpStatusHidden,
    status,
  } = state.home;

  return {
    isMnpStatusHidden,
    data: status && status.data && status.data.mnpStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      hideMnpStatusForSession,
    }, dispatch),
  };
}

MnpStatus.propTypes = {
  data: PropTypes.object,
  actions: PropTypes.object,
  isMnpStatusHidden: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(MnpStatus);
